import React, { Component } from "react";
import Swal from "sweetalert2";

const hiddenFileInput = React.createRef(null);

class ModalPrecertificado extends Component {
  render() {
    return (
      <>
        <div>
          <fieldset className="panel">
            <legend>Información producto</legend>
            <div className="container">
              <div className="row">
                <div className="col-lg-6">
                  <div className="form-group">
                    <label>
                      Tipo subproductos: <span className="text-danger"> *</span>
                    </label>
                    <select
                      name="tipo_subproductos"
                      id="tipo_subproducto"
                      onChange={(e) =>
                        this.props.component.handleChangeSubproducto(e)
                      }
                      value={this.props.state.subproducto_tipo_id}
                      className="form-control"
                      required
                    >
                      <option value="">Seleccione</option>
                      {this.props.state.tipos_subproductos.map((option) => (
                        <option key={option.id} value={option.id}>
                          {option.descripcion}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group">
                    <label>
                      Producto: <span className="text-danger"> *</span>
                    </label>
                    <select
                      name="producto"
                      id="producto"
                      onChange={(e) =>
                        this.props.component.handleChangeProducto(e)
                      }
                      value={this.props.state.producto_id}
                      className="form-control"
                      required
                    >
                      <option value="">Seleccione</option>
                      {this.props.state.productos.map((option) => (
                        <option key={option.id} value={option.id}>
                          {option.nombre_comercial /*LISTAPROD*/ +
                            "(" +
                            option.no_registro +
                            ")"}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="col-lg-10">
                  <div className="form-group">
                    <label>
                      Presentación: <span className="text-danger"> *</span>
                    </label>
                    <select
                      name="presentacion"
                      id="presentacion"
                      onChange={(e) =>
                        this.props.component.handleChangePresentacion(e)
                      }
                      value={this.props.state.presentacion}
                      className="form-control"
                      required
                    >
                      <option value="">Seleccione</option>
                      {this.props.state.presentaciones.map((option) => (
                        <option key={option.id} value={option.id}>
                          {option.empaque} ({option.cantidad}{" "}
                          {option.unidad_medida})
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="col-lg-2">
                  <div className="form-group">
                    <label>
                      Cantidad: <span className="text-danger"> *</span>{" "}
                    </label>
                    <input
                      type="text"
                      value={this.props.state.cantidad}
                      name="cantidad"
                      //pattern="[0-9]{0,7}" //expresion que solo permite numeros de tam 7
                      maxLength={7}
                      onChange={(e) =>
                        this.props.component.handleCantidadChange(e)
                      }
                      className="form-control"
                      id="cantidad"
                      title="Cantidad"
                      placeholder="##"
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-2">
                  <div className="form-group">
                    <label>
                      Peso neto (KG): <span className="text-danger"> *</span>
                    </label>
                    <input
                      type="text"
                      value={this.props.state.peso_neto}
                      name="peso_neto"
                      maxLength={6}
                      //pattern="[+-]?\d+(?:[.,]\d+)?"
                      onChange={(e) =>
                        this.props.component.handlePesoNetoChange(e)
                      }
                      className="form-control"
                      id="preso_neto"
                      title="Peso neto en kilogramos"
                      placeholder="##.##"
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-2">
                  <div className="form-group">
                    <label>
                      No. Lote: <span className="text-danger"> *</span>
                    </label>
                    <input
                      type="text"
                      value={this.props.state.no_lote}
                      name="no_lote"
                      maxLength={20}
                      //pattern="[0-9]{0,20}" //expresion que solo permite numeros de tam 7
                      onChange={(e) =>
                        this.props.component.handleNoLoteChange(e)
                      }
                      className="form-control"
                      id="no_lote"
                      title="Número del lote"
                      placeholder="Número del lote"
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="form-group">
                    <label>
                      Código de producción:{" "}
                      <span className="text-danger"> *</span>
                    </label>
                    <input
                      type="text"
                      value={this.props.state.codigo_produccion}
                      name="codigo_produccion"
                      maxLength={20}
                      onChange={(e) =>
                        this.props.component.handleCodigoProduccionChange(e)
                      }
                      className="form-control"
                      id="codigo_produccion"
                      title="Código de producción"
                      placeholder="Código de producción"
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="form-group">
                    <label>Fabricante: </label>
                    <input
                      type="text"
                      value={this.props.state.fabricante}
                      name="fabricante"
                      disabled={true}
                      className="form-control"
                      id="fabricante"
                      title="Fabricante"
                      placeholder="Fabricante"
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="form-group">
                    <label>Descripción del producto: </label>
                    <span className="text-danger"> *</span>{" "}
                    <textarea
                      className="form-control"
                      placeholder="Descripción del producto"
                      maxLength={500}
                      rows="5"
                      name="descripcion_producto"
                      value={this.props.state.descripcion_producto}
                      onChange={(e) =>
                        this.props.component.handleDescripcionChange(e)
                      }
                      required
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
          <hr></hr>
          <fieldset className="panel">
            <legend>Establecimiento exportador</legend>
            <div className="container">
              <div className="row">
                <div className="form-group col-md-6">
                  <label>Razón social</label>
                  <span className="text-danger"> *</span>{" "}
                  <input
                    type="text"
                    name="razon_social"
                    id="razon_social_e"
                    onChange={this.props.component.handleEstablecimiento}
                    value={this.props.state.establecimiento.razon_social}
                    className="form-control"
                    //placeholder="Ingrese razón social "
                    required
                    disabled={this.props.state.disable_establecimiento}
                    required
                  />
                </div>

                <div className="form-group col-md-5">
                  <label>GUID</label>
                  <span className="text-danger"> *</span>{" "}
                  <input
                    type="text"
                    name="guid"
                    id="guid_e"
                    onChange={this.props.component.handleEstablecimiento}
                    value={this.props.state.establecimiento.guid}
                    className="form-control"
                    maxLength="4"
                    placeholder="Ingrese GUID "
                    required
                    disabled={this.props.state.disable_establecimiento}
                  />
                </div>

                <div
                  className="col-md-1"
                  aria-disabled={this.props.state.disable_establecimiento}
                >
                  <br />
                  <div
                    id="addEst"
                    //disabled={this.props.state.disable_establecimiento}
                    onClick={this.props.component.handleGuidEstablecimiento}
                    className=" btn btn-light"
                  >
                    <i
                      className="fa fa-th"
                      //disabled={this.props.state.disable_establecimiento}
                    ></i>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
          <hr></hr>
          <fieldset className="panel">
            <legend>Información {this.props.state.aux_tipo_subproducto}</legend>
            <div className="container">
              <div className="row">
                <div className="col-lg-6">
                  <div className="form-group">
                    <label>
                      Nombre {this.props.state.aux_tipo_subproducto}:{" "}
                      <span className="text-danger"> *</span>
                    </label>
                    <input
                      type="text"
                      value={this.props.state.nombre}
                      name="nombre"
                      maxLength={120}
                      onChange={(e) =>
                        this.props.component.handleChangeNombre(e)
                      }
                      className="form-control"
                      id="nombre"
                      title="Nombre"
                      placeholder="Nombre"
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group">
                    <label>
                      Dirección {this.props.state.aux_tipo_subproducto}:{" "}
                      <span className="text-danger"> *</span>
                    </label>
                    <input
                      type="text"
                      value={this.props.state.direccion}
                      name="direccion"
                      maxLength={120}
                      onChange={(e) =>
                        this.props.component.handleChangeDireccion(e)
                      }
                      className="form-control"
                      id="direccion"
                      title="Direccion"
                      placeholder="Direccion"
                      required
                    />
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
          <hr></hr>
          {this.props.state.subproducto_tipo_id !== "4" ? (
            <>
              <fieldset className="panel">
                <legend>Información del destinatario final</legend>
                <div className="container">
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="form-group" id="nombre_f">
                        <label>
                          Nombre del destinatario final:{" "}
                          <span className="text-danger"> *</span>
                        </label>
                        <input
                          type="text"
                          value={this.props.state.nombre_final}
                          name="nombre_final"
                          maxLength={120}
                          onChange={(e) =>
                            this.props.component.handleChangeNombreFinal(e)
                          }
                          className="form-control"
                          id="nombre_final"
                          title="Nombre del destinatario final "
                          placeholder="Nombre del destinatario final "
                          required
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group" id="direccion_f">
                        <label>
                          Dirección del destinatario final:{" "}
                          <span className="text-danger"> *</span>
                        </label>
                        <input
                          type="text"
                          value={this.props.state.direccion_final}
                          name="direccion_final"
                          maxLength={120}
                          onChange={(e) =>
                            this.props.component.handleChangeDireccionFinal(e)
                          }
                          className="form-control"
                          id="direccion_final"
                          title="Direccion del destinatario final"
                          placeholder="Direccion del destinatario final"
                          required
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </fieldset>
              <hr></hr>
            </>
          ) : null}
          <fieldset className="panel">
            <legend>Información del medio de transporte</legend>
            <div className="container">
              <div className="row">
                <div className="col-lg-3">
                  <div className="form-group">
                    <label>
                      Número de contenedor:{" "}
                      <span className="text-danger"> *</span>{" "}
                    </label>
                    <input
                      type="text"
                      value={this.props.state.no_contenedor}
                      name="no_contenedor"
                      //pattern="[0-9]{0,7}" //expresion que solo permite numeros de tam 7
                      maxLength={7}
                      onChange={(e) =>
                        this.props.component.handleNoContenerdorChange(e)
                      }
                      className="form-control"
                      id="no_contenedor"
                      title="no_contenedor"
                      placeholder="##"
                      required
                    />
                  </div>
                </div>
                {/*  <div className="col-lg-4">
                  <div className="form-group">
                    <label>
                      Número de marchamo:{" "}
                    </label>
                    <input
                      type="text"
                      value={this.props.state.no_marchamo}
                      name="no_marchamo"
                      //11pattern="[0-9]{0,7}" //expresion que solo permite numeros de tam 7
                      //maxLength={7}
                      maxLength={30}
                      onChange={(e) =>
                        this.props.component.handleNoMarchamoChange(e)
                      }
                      className="form-control"
                      id="no_marchamo"
                      title="no_marchamo"
                      placeholder="##"
                    />
                  </div>
                </div> */}
                <div className="form-group col-md-3">
                  <div className="form-group">
                    <label>
                      Fecha de embarque: <span className="text-danger"> *</span>
                    </label>
                    <input
                      type="date"
                      name="fecha"
                      onChange={(e) =>
                        this.props.component.handleChangeFecha(e)
                      }
                      id="fecha"
                      value={this.props.state.fecha}
                      className="form-control"
                      placeholder="Seleccione una fecha"
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-3">
                  <div className="form-group">
                    <label>
                      Puerto de salida: <span className="text-danger"> *</span>
                    </label>
                    <input
                      type="text"
                      value={this.props.state.puerto_salida}
                      name="puerto_salida"
                      maxLength={200}
                      onChange={(e) =>
                        this.props.component.handlePuertoSalidaChange(e)
                      }
                      className="form-control"
                      id="puerto_salida"
                      title="Puerto de salida"
                      placeholder="Puerto de salida"
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-3">
                  <div className="form-group">
                    <label>
                      Puerto de entrada: <span className="text-danger"> *</span>
                    </label>
                    <input
                      type="text"
                      value={this.props.state.puerto_entrada}
                      name="puerto_entrada"
                      maxLength={200}
                      onChange={(e) =>
                        this.props.component.handlePuertoEntradaChange(e)
                      }
                      className="form-control"
                      id="puerto_entrada"
                      title="Puerto de entrada"
                      placeholder="Puerto de entrada"
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="form-group">
                    <label>
                      Compañía transportadora:{" "}
                      <span className="text-danger"> *</span>
                    </label>
                    <input
                      type="text"
                      value={this.props.state.compania_transportadora}
                      name="compania_transportadora"
                      maxLength={200}
                      onChange={(e) =>
                        this.props.component.handleCompaniaTransportadoraChange(
                          e
                        )
                      }
                      className="form-control"
                      id="compania_transportadora"
                      title="Compañia transportadora"
                      placeholder="Compañia transportadora"
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="form-group">
                    <label>
                      Medio de transporte :{" "}
                      <span className="text-danger"> *</span>
                    </label>
                    <select
                      name="medio_transporte"
                      id="medio_transporte"
                      onChange={(e) =>
                        this.props.component.handleMedioChange(e)
                      }
                      value={this.props.state.medio_transporte_id}
                      className="form-control"
                      required
                    >
                      <option value="">Seleccione</option>
                      {this.props.state.medio_transportes.map((option) => (
                        <option key={option.id} value={option.id}>
                          {option.descripcion}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="form-group">
                    <label>
                      Identificación del medio de transporte:{" "}
                      <span className="text-danger"> *</span>
                    </label>
                    <input
                      type="text"
                      value={this.props.state.identificacion_transporte}
                      name="identificacion_transporte"
                      maxLength={200}
                      onChange={(e) =>
                        this.props.component.handleIdentificacionChange(e)
                      }
                      className="form-control"
                      id="identificacion_transporte"
                      title="Identificación del medio de transporte"
                      placeholder="Identificación del medio de transporte"
                      required
                    />
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
          {this.props.state.registros_docs !== 0 ? (
            <>
              <hr></hr>
              <fieldset>
                <legend>Documentación</legend>
                <div className="row">
                  <div className="form-group col-md-10">
                    <label>
                      <span className="text-danger">
                        {" "}
                        Solo se aceptan archivos ".pdf"*
                      </span>
                    </label>
                    <select
                      name="tipo_documento"
                      id="tipo_documento"
                      onChange={(e) =>
                        this.props.component.handleChangeTipoDocumento(e)
                      }
                      value={this.props.state.tipo_documento_id}
                      className="form-control"
                    >
                      <option value="">Seleccione el documento...</option>
                      {this.props.state.tipo_documentos.map((option) => (
                        <option key={option.id} value={option.id}>
                          {option.descripcion}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-2" style={{ marginTop: "1.7%" }}>
                    <button
                      type="button"
                      name="b_documento"
                      className="btn btn-primary"
                      onClick={(e) => {
                        if (this.props.state.tipo_documento_id === "") {
                          Swal.fire({
                            title: "Atención",
                            text: "Seleccione tipo de documento a cargar.",
                          });
                          return;
                        } else {
                          hiddenFileInput.current.click();
                        }
                      }}
                    >
                      Seleccionar archivo
                    </button>
                    <input
                      type="file"
                      accept=".pdf"
                      ref={hiddenFileInput}
                      name="documento"
                      onChange={(e) =>
                        this.props.component.handleFile(e.target)
                      }
                      onClick={(e) => {
                        //this.props.component.validarseleccion(event);
                        e.target.value = null;
                      }}
                      style={{ display: "none" }}
                    />
                  </div>
                </div>
                <hr></hr>
                <div className="table-responsive">
                  <table className="table table-striped m-b-0 table-hover">
                    <thead>
                      <tr>
                        <th className="text-center">Tipo documento</th>
                        <th className="text-center">Nombre documento</th>
                        <th className="text-center">Vista previa</th>
                        <th className="text-center"> </th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.props.state.documentos.length > 0 ? (
                        this.props.state.documentos.map((doc, index) => (
                          <tr key={index} id={index}>
                            <td className="text-center">
                              {doc.tipo_documento}
                            </td>
                            <td className="text-center">{doc.nombre}</td>
                            <td className="text-center">
                              <div
                                onClick={(e) =>
                                  this.props.component.handleVistaPrevia(e)
                                }
                                data-file={doc.pdf}
                                name="pdf"
                                className="btn btn-danger"
                                id={index}
                                width="60"
                                title="Vista previa"
                              >
                                <i
                                  className="fa fa-file-pdf"
                                  name="pdf"
                                  id={index}
                                ></i>
                              </div>
                            </td>
                            <td className="text-center">
                              <div
                                className="btn btn-warning remover-documento"
                                id={index}
                                title="Remover"
                                data-tipo_documento_id={doc.tipo_documento_id}
                                data-descripcion={doc.tipo_documento}
                                onClick={this.props.component.removeDocumento}
                              >
                                <i
                                  className="fas fa-trash"
                                  id={index}
                                  title="Remover"
                                  data-tipo_documento_id={doc.tipo_documento_id}
                                  data-descripcion={doc.tipo_documento}
                                  onClick={this.props.component.removeDocumento}
                                ></i>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td className="text-center"></td>
                          <td className="text-center">No hay documentos</td>
                          <td className="text-left"></td>
                          <td className="text-center"></td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </fieldset>
            </>
          ) : null}
          {/*
          <hr></hr>
          <fieldset className="panel">
            <legend>
              Observaciones<span className="text-danger"> *</span>{" "}
            </legend>
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="form-group">
                    <textarea
                      className="form-control"
                      placeholder="Observaciones"
                      maxLength={500}
                      rows="5"
                      name="observaciones"
                      value={this.props.state.observaciones}
                      onChange={(e) =>
                        this.props.component.handleObservacionChange(e)
                      }
                      required
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
                    </fieldset>*/}
          <div className={this.props.state.previa ? "previa" : "hide"}>
            <iframe
              title="Vista previa"
              src={`data:application/pdf;base64,${this.props.state.previa_url}`}
              width="100%"
              height="100%"
              name="iframe"
            ></iframe>
            <center>
              <div className="btn-group">
                <div
                  onClick={(e) => {
                    this.props.component.handleCloseVistaPrevia(e);
                  }}
                  className="btn btn-danger"
                >
                  Regresar
                </div>
              </div>
            </center>
          </div>
          <div className="btn-group float-right">
            <button
              type="button"
              onClick={() => {
                this.props.component.closeModal();
              }}
              className="btn btn-danger"
            >
              Regresar
            </button>
            <button
              type="submit"
              className="btn btn-success btn-block"
              onClick={(e) => {
                this.props.component.handleSubmit(e);
              }}
            >
              Aceptar
            </button>
          </div>
        </div>
      </>
    );
  }
}

export default ModalPrecertificado;
